import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import s from './InheritanceSalvage.scss';

class InheritanceSalvage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul className="breadcrumb">
              <li>
                <a href="https://fluxtech.co">Home</a>
              </li>
              <li>
                <a href="https://fluxtech.co/portfolio">Portfolio</a>
              </li>
              <li>Inheritance Salvage</li>
            </ul>
          }
          header="Inheritance Salvage"
          link="/projects/inheritance-salvage"
          subHeader="Hidden jems from our store to your home"
        />
        <section className={s.sara}>
          <h5>
            "Inheritance Salvage was the first website that I've ever had the
            pleasure of working on, and I'm very happy with the way it turned
            out."
            <br />
            <br />
            <span>- Owner, Jonathan Emig</span>
          </h5>
          <div className={s.about}>
            <div className={s.content}>
              <h3>About</h3>
              <p>
                Inheritance Salvage is much more than a junk store. We are a
                retail shop that specializes in vintage, antique and repurposed
                decor and furniture.
              </p>
            </div>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/inheritancesalvage-iphone-home-v1.png"
              />
            </div>
          </div>

          <div className={s.challenge}>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/inheritancesalvage-iphone-crew-v1.png"
              />
            </div>
            <div className={s.content}>
              <h3>Challenge</h3>
              <p>
                We were tasked to build a simple imformational website for the
                small business of Inheritance Salvage.
              </p>
            </div>
          </div>

          <div className={s.solution}>
            <div className={s.content}>
              <h3>Solution</h3>
              <p>
                The solution was to build three pages that showed the owners of
                the store as well as a few of the products that they sell. We
                also added a map to allow people to more easily find their
                store.
              </p>
            </div>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/inheritancesalvage-iphone-treasures-v1.png"
              />
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(InheritanceSalvage);
